import { useSelector } from 'react-redux';
import currentDealSelectors from '../../store/selectors/currentDealSelectors';
import { useIntl } from 'react-intl';
import { useMemo } from 'react';

const useFinanceDisclaimers = () => {
  const intl = useIntl();
  const rawFinanceDisclaimers: string[] = useSelector(currentDealSelectors.getFinanceDisclaimers) || [];

  const financeDisclaimers: string[] = useMemo(
    () =>
      rawFinanceDisclaimers.map((disclaimer: string) => {
        const translationKey = 'spc.productConfigure.disclaimer.disclaimerInfo';
        const disclaimerInfo: string = intl.formatMessage({ id: translationKey });
        let currentDisclaimer = disclaimer;

        if (disclaimerInfo.length > 1 && disclaimerInfo !== translationKey) {
          currentDisclaimer = disclaimer.replace('*', disclaimerInfo);
        }

        return intl.formatMessage({ id: 'spc.customise.indicative.repayment' }) + ' ' + currentDisclaimer;
      }),
    [intl, rawFinanceDisclaimers],
  );

  return { financeDisclaimers };
};

export default useFinanceDisclaimers;
